export const TOGGLE_FILTER = 'TOGGLE_FILTER';

export const toggleFilter = () => ({
  type: TOGGLE_FILTER,
});

export default {
  toggleFilter,
};
